<template>
  <v-app-bar dense flat fixed elevate-on-scroll>
    <router-link
      style="display: flex; cursor: pointer"
      to="/home/#"
      link
      @click.prevent="scrollToHome"
    >
      <img class="mr-3" src="../assets/pc-logo.png" height="40" />
      <v-toolbar-title
        ><svg
          width="605"
          height="40"
          viewBox="0 0 605 40"
          xmlns="http://www.w3.org/2000/svg"
          alt="PackerCrew GmbH"
        >
          <g
            id="svgGroup"
            stroke-linecap="round"
            fill-rule="evenodd"
            font-size="9pt"
            stroke="#E7B202"
            stroke-width="0.25mm"
            fill="#E7B202"
            style="stroke: #e7b202; stroke-width: 0.25mm; fill: #e7b202"
          >
            <path
              d="M 591.6 18.6 L 605 18.6 L 588.8 74 L 573.7 74 L 563.6 35.3 L 553.5 74 L 538.3 74 L 522 18.6 L 536.2 18.6 L 546 60.8 L 556.6 18.6 L 571.4 18.6 L 581.8 60.7 L 591.6 18.6 Z M 414.1 25.9 L 398 25.9 A 18.26 18.26 0 0 0 394.953 21.351 A 15.659 15.659 0 0 0 391.25 18.4 A 18.772 18.772 0 0 0 384.133 16.076 A 23.762 23.762 0 0 0 381.2 15.9 A 22.278 22.278 0 0 0 374.765 16.802 A 19.37 19.37 0 0 0 370.35 18.75 A 19.413 19.413 0 0 0 363.033 26.638 A 23.081 23.081 0 0 0 362.95 26.8 A 23.758 23.758 0 0 0 360.737 33.61 A 31.834 31.834 0 0 0 360.3 39 Q 360.3 45.9 362.95 51.15 A 20.031 20.031 0 0 0 367.459 57.121 A 18.88 18.88 0 0 0 370.35 59.25 A 20.094 20.094 0 0 0 379.143 62.016 A 24.721 24.721 0 0 0 381.2 62.1 A 21.65 21.65 0 0 0 386.719 61.422 A 17.915 17.915 0 0 0 391.25 59.55 A 16.541 16.541 0 0 0 397.202 53.503 A 20.652 20.652 0 0 0 398 52 L 414.1 52 A 32.96 32.96 0 0 1 408.4 62.66 A 30.434 30.434 0 0 1 401.85 68.65 A 34.399 34.399 0 0 1 385.705 74.382 A 43.597 43.597 0 0 1 381.3 74.6 A 37.877 37.877 0 0 1 369.562 72.823 A 34.224 34.224 0 0 1 363.25 70.05 Q 355.2 65.5 350.55 57.4 A 35.184 35.184 0 0 1 346.063 42.785 A 43.081 43.081 0 0 1 345.9 39 A 39.081 39.081 0 0 1 347.496 27.668 A 34.272 34.272 0 0 1 350.55 20.55 Q 355.2 12.4 363.25 7.85 A 35.407 35.407 0 0 1 378.83 3.371 A 42.429 42.429 0 0 1 381.3 3.3 A 38.518 38.518 0 0 1 393.071 5.044 A 33.481 33.481 0 0 1 401.8 9.3 Q 410.6 15.3 414.1 25.9 Z M 239.8 74 L 221.6 74 L 202.8 50.4 L 202.8 74 L 188.8 74 L 188.8 0 L 202.8 0 L 202.8 42.1 L 221.4 18.6 L 239.6 18.6 L 215.2 46.4 L 239.8 74 Z M 178.5 37.3 L 163.4 37.3 A 11.816 11.816 0 0 0 161.561 33.783 A 10.582 10.582 0 0 0 159.35 31.65 A 10.689 10.689 0 0 0 155.028 29.842 A 14.707 14.707 0 0 0 152.3 29.6 A 13.32 13.32 0 0 0 147.916 30.291 A 11.172 11.172 0 0 0 142.8 33.95 A 14.401 14.401 0 0 0 140.317 38.736 Q 139.3 41.988 139.3 46.3 Q 139.3 51.854 141.03 55.653 A 13.556 13.556 0 0 0 142.8 58.55 Q 146.3 62.9 152.3 62.9 A 14.436 14.436 0 0 0 156.615 62.299 Q 161.07 60.907 163.023 56.29 A 15.032 15.032 0 0 0 163.4 55.3 L 178.5 55.3 A 27.43 27.43 0 0 1 174.713 63.928 A 24.602 24.602 0 0 1 169.4 69.6 A 24.676 24.676 0 0 1 158.443 74.382 A 33.858 33.858 0 0 1 152.4 74.9 A 30.795 30.795 0 0 1 144.408 73.898 A 25.936 25.936 0 0 1 138.2 71.35 Q 132 67.8 128.5 61.35 Q 125 54.9 125 46.3 A 35.706 35.706 0 0 1 125.821 38.473 A 27.831 27.831 0 0 1 128.5 31.25 Q 132 24.8 138.2 21.25 A 26.935 26.935 0 0 1 148.927 17.876 A 33.561 33.561 0 0 1 152.4 17.7 A 33.873 33.873 0 0 1 160.114 18.534 A 24.292 24.292 0 0 1 169.45 22.85 A 23.995 23.995 0 0 1 177.382 33.693 A 31.56 31.56 0 0 1 178.5 37.3 Z M 298.3 50.5 L 257.8 50.5 Q 258.3 56.5 262 59.9 A 12.795 12.795 0 0 0 270.349 63.283 A 16.604 16.604 0 0 0 271.1 63.3 Q 278.9 63.3 282.2 56.6 L 297.3 56.6 Q 294.9 64.6 288.1 69.75 A 25.141 25.141 0 0 1 276.582 74.515 A 33.694 33.694 0 0 1 271.4 74.9 A 30.891 30.891 0 0 1 262.537 73.665 A 27.022 27.022 0 0 1 257.05 71.35 Q 250.7 67.8 247.15 61.3 Q 243.6 54.8 243.6 46.3 A 35.78 35.78 0 0 1 244.448 38.343 A 28.183 28.183 0 0 1 247.1 31.2 Q 250.6 24.7 256.9 21.2 A 27.733 27.733 0 0 1 266.938 17.977 A 35.017 35.017 0 0 1 271.4 17.7 A 31.503 31.503 0 0 1 279.765 18.776 A 27.018 27.018 0 0 1 285.55 21.1 Q 291.8 24.5 295.25 30.75 A 27.694 27.694 0 0 1 298.457 40.927 A 34.879 34.879 0 0 1 298.7 45.1 A 38.688 38.688 0 0 1 298.602 47.929 A 28.241 28.241 0 0 1 298.3 50.5 Z M 517.6 50.5 L 477.1 50.5 Q 477.6 56.5 481.3 59.9 A 12.795 12.795 0 0 0 489.649 63.283 A 16.604 16.604 0 0 0 490.4 63.3 Q 498.2 63.3 501.5 56.6 L 516.6 56.6 Q 514.2 64.6 507.4 69.75 A 25.141 25.141 0 0 1 495.882 74.515 A 33.694 33.694 0 0 1 490.7 74.9 A 30.891 30.891 0 0 1 481.837 73.665 A 27.022 27.022 0 0 1 476.35 71.35 Q 470 67.8 466.45 61.3 Q 462.9 54.8 462.9 46.3 A 35.78 35.78 0 0 1 463.748 38.343 A 28.183 28.183 0 0 1 466.4 31.2 Q 469.9 24.7 476.2 21.2 A 27.733 27.733 0 0 1 486.238 17.977 A 35.017 35.017 0 0 1 490.7 17.7 A 31.503 31.503 0 0 1 499.065 18.776 A 27.018 27.018 0 0 1 504.85 21.1 Q 511.1 24.5 514.55 30.75 A 27.694 27.694 0 0 1 517.757 40.927 A 34.879 34.879 0 0 1 518 45.1 A 38.688 38.688 0 0 1 517.902 47.929 A 28.241 28.241 0 0 1 517.6 50.5 Z M 100.8 26.5 L 100.8 18.6 L 114.9 18.6 L 114.9 74 L 100.8 74 L 100.8 65.9 A 19.688 19.688 0 0 1 95.86 70.809 A 24.679 24.679 0 0 1 93.35 72.35 A 21.31 21.31 0 0 1 86.133 74.651 A 27.168 27.168 0 0 1 82.4 74.9 Q 75.4 74.9 69.65 71.3 A 24.734 24.734 0 0 1 61.425 62.741 A 29.952 29.952 0 0 1 60.55 61.15 Q 57.2 54.6 57.2 46.1 Q 57.2 37.7 60.55 31.2 A 26.056 26.056 0 0 1 65.374 24.539 A 23.289 23.289 0 0 1 69.65 21.2 A 24.182 24.182 0 0 1 82.278 17.701 A 28.681 28.681 0 0 1 82.5 17.7 A 26.101 26.101 0 0 1 87.972 18.249 A 20.239 20.239 0 0 1 93.35 20.2 A 23.797 23.797 0 0 1 98.108 23.525 A 20.199 20.199 0 0 1 100.8 26.5 Z M 25.7 47.2 L 14 47.2 L 14 74 L 0 74 L 0 4.2 L 25.7 4.2 Q 32.973 4.2 38.312 6.458 A 23.122 23.122 0 0 1 39.5 7 A 21.635 21.635 0 0 1 44.554 10.385 A 18.105 18.105 0 0 1 48.05 14.7 A 21.146 21.146 0 0 1 50.83 23.894 A 25.73 25.73 0 0 1 50.9 25.8 Q 50.9 31.4 48.25 36.3 A 18.333 18.333 0 0 1 42.778 42.445 A 23.873 23.873 0 0 1 39.95 44.2 A 23.866 23.866 0 0 1 34.005 46.353 Q 31.261 46.975 28.068 47.14 A 45.857 45.857 0 0 1 25.7 47.2 Z M 339.9 17.8 L 339.9 32.5 L 336.2 32.5 A 22.449 22.449 0 0 0 332.48 32.788 Q 330.476 33.125 328.887 33.858 A 10.037 10.037 0 0 0 326.25 35.6 A 8.784 8.784 0 0 0 324.144 38.724 Q 322.9 41.708 322.9 46.4 L 322.9 74 L 308.9 74 L 308.9 18.6 L 322.9 18.6 L 322.9 27.2 Q 325.6 22.8 329.95 20.3 A 18.85 18.85 0 0 1 337.51 17.92 A 23.395 23.395 0 0 1 339.9 17.8 Z M 457.1 17.8 L 457.1 32.5 L 453.4 32.5 A 22.449 22.449 0 0 0 449.68 32.788 Q 447.676 33.125 446.087 33.858 A 10.037 10.037 0 0 0 443.45 35.6 A 8.784 8.784 0 0 0 441.344 38.724 Q 440.1 41.708 440.1 46.4 L 440.1 74 L 426.1 74 L 426.1 18.6 L 440.1 18.6 L 440.1 27.2 Q 442.8 22.8 447.15 20.3 A 18.85 18.85 0 0 1 454.71 17.92 A 23.395 23.395 0 0 1 457.1 17.8 Z M 100.8 46.3 A 21.755 21.755 0 0 0 100.417 42.115 A 15.729 15.729 0 0 0 98.8 37.55 A 14.54 14.54 0 0 0 95.388 33.335 A 13.72 13.72 0 0 0 93.4 31.95 Q 90 30 86.1 30 Q 82.2 30 78.9 31.9 A 13.928 13.928 0 0 0 74.256 36.299 A 17.098 17.098 0 0 0 73.55 37.45 A 15.719 15.719 0 0 0 71.788 42.54 A 21.102 21.102 0 0 0 71.5 46.1 A 20.612 20.612 0 0 0 71.981 50.65 A 16.106 16.106 0 0 0 73.55 54.85 A 15.763 15.763 0 0 0 76.399 58.644 A 13.876 13.876 0 0 0 78.95 60.6 Q 82.3 62.6 86.1 62.6 Q 90 62.6 93.4 60.65 A 14.018 14.018 0 0 0 98.609 55.388 A 16.714 16.714 0 0 0 98.8 55.05 A 15.793 15.793 0 0 0 100.444 50.345 A 21.887 21.887 0 0 0 100.8 46.3 Z M 25.1 15.6 L 14 15.6 L 14 35.9 L 25.1 35.9 A 20.157 20.157 0 0 0 28.27 35.668 Q 29.918 35.405 31.229 34.843 A 8.321 8.321 0 0 0 33.7 33.25 A 8.656 8.656 0 0 0 36.169 28.846 A 13.199 13.199 0 0 0 36.5 25.8 A 13.025 13.025 0 0 0 35.874 21.579 Q 33.828 15.6 25.1 15.6 Z M 257.9 41.1 L 284.2 41.1 A 12.638 12.638 0 0 0 283.457 36.927 A 10.707 10.707 0 0 0 280.3 32.45 A 13.474 13.474 0 0 0 272.431 29.257 A 17.54 17.54 0 0 0 271 29.2 A 14.181 14.181 0 0 0 266.488 29.892 A 12.092 12.092 0 0 0 262.25 32.35 A 12.689 12.689 0 0 0 258.669 37.839 A 17.77 17.77 0 0 0 257.9 41.1 Z M 477.2 41.1 L 503.5 41.1 A 12.638 12.638 0 0 0 502.757 36.927 A 10.707 10.707 0 0 0 499.6 32.45 A 13.474 13.474 0 0 0 491.731 29.257 A 17.54 17.54 0 0 0 490.3 29.2 A 14.181 14.181 0 0 0 485.788 29.892 A 12.092 12.092 0 0 0 481.55 32.35 A 12.689 12.689 0 0 0 477.969 37.839 A 17.77 17.77 0 0 0 477.2 41.1 Z"
              vector-effect="non-scaling-stroke"
            />
          </g></svg>
        </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>

    <v-list :class="showMenu ? 'show-menu' : ''">
      <v-list-item-group v-model="selectedItem">
        <v-list-item to="/home/#" link @click.prevent="scrollToHome">
          <v-list-item-content>
            <v-list-item-title>HOME</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/home/#uber_uns" link @click.prevent="scrollToUberUns">
          <v-list-item-content>
            <v-list-item-title>ÜBER UNS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          to="/home/#dienstleistungen"
          link
          @click.prevent="scrollToServices"
        >
          <v-list-item-content>
            <v-list-item-title>UNSERE DIENSTLEISTUNGEN</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/kontakt" link @click.prevent="isMobileScreen">
          <v-list-item-content>
            <v-list-item-title>KONTAKT</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <!-- Icons Buttons Section -->
    <!-- <v-btn icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn> -->

    <v-app-bar-nav-icon
      @click.prevent="showMenu = !showMenu"
    ></v-app-bar-nav-icon>
  </v-app-bar>
</template>

<script>
export default {
  name: "NavigationLayout",

  data: () => ({
    selectedItem: null,
    showMenu: false,
  }),

  methods: {
    isMobileScreen() {
      this.showMenu ? (this.showMenu = false) : this.showMenu;
    },
    scrollToHome() {
      this.isMobileScreen();

      const target = document.getElementById("h1-Home");
      // Check if the target is on the current page
      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: "smooth",
        });
      } else {
        // Navigate to the target page and scroll to the target
        this.$router.push("/#home");
      }
    },
    scrollToUberUns() {
      this.isMobileScreen();

      const target = document.getElementById("h2-UberUns");
      // Check if the target is on the current page
      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: "smooth",
        });
      } else {
        // Navigate to the target page and scroll to the target
        this.$router.push("/#uber_uns");
      }
    },
    scrollToServices() {
      this.isMobileScreen();

      const target = document.getElementById("h4-Services");
      // Check if the target is on the current page
      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: "smooth",
        });
      } else {
        // Navigate to the target page and scroll to the target
        this.$router.push("/#dienstleistungen");
      }
    },
  },
};
</script>

<style scoped>
.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  /* box-shadow: 0px 0px 3px #ccc !important; */
  background: #333;
  color: #fff;
}

.v-toolbar__title {
  color: #e7b202;
  font-weight: 600;
  display: flex;
  font-size: 1.3em;
  width: 160px;
  align-items: center;
}

.v-list.v-sheet {
  display: none;
  padding: 0;
}

.v-list.v-sheet.show-menu {
  display: flex;
}

.v-list.v-sheet.is-active {
  display: flex;
}

.v-list.v-sheet {
  position: absolute;
  color: #fff;
  top: 48px;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  background-color: #333;
}

.v-item-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.v-list-item__content {
  color: #fff;
}

a.v-item--active.v-list-item--active .v-list-item__content {
  border-bottom: 1px solid #e7b202;
}

a.v-item--active.v-list-item--active::before {
  opacity: 0;
}

.v-list-item {
  max-height: 48px;
}

.v-app-bar__nav-icon .v-icon {
  color: #fff;
}

/* Toggle Menu list on mobiles or smaller screens */

@media screen and (min-width: 832px) {
  .v-list.v-sheet {
    display: flex;
    position: relative;
    background: transparent;
    top: 0;
    left: 0;
    right: 0;
    height: unset;
    width: unset;
  }

  .v-item-group {
    flex-direction: row;
  }

  button.v-app-bar__nav-icon {
    display: none;
  }
}
</style>
